export function uniqeId() {
  return 'id-' + Math.random().toString(36).substr(2, 16);
}

export function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj))
}
